<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveAndRefreshPage" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(autofocus :placeholder='$t("users.name_placeholder")' :danger="$v.form.name.$invalid && $v.form.name.$model" :danger-text="$t('validation.required', { attribute: $t('users.name') })" v-model="form.name" :label='$t("users.name")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("users.email_placeholder")' :danger="$v.form.email.$invalid && typeof $v.form.email.$model !== 'undefined'" :danger-text="$t('validation.email', { attribute: $t('users.email') })" v-model="form.email" :label='$t("users.email")' required)
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("users.password_placeholder")' type="password" :danger="$v.form.password.$invalid && typeof $v.form.password.$model !== 'undefined'" :danger-text="$v.form.password.minLength ? $v.form.password.required ? '' : $t('validation.required', { attribute: $t('users.password') }) : $t('validation.min.string', { attribute: $t('users.password'), min: 4 })" :description-text='isAdd ? "" : $t("users.leave_empty")' v-model="form.password" :label='$t("users.password")' required)
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("users.confirm_password_placeholder")' type="password" :danger="$v.form.confirm_password.$invalid && typeof $v.form.confirm_password.$model !== 'undefined'" :danger-text="$t('validation.same', { attribute: $t('users.confirm_password'), other: $t('users.password') })" v-model="form.confirm_password" :label='$t("users.confirm_password")' required)
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-select(:placeholder='$t("users.role_placeholder")' :danger="$v.form.role.$invalid && $v.form.role.$model" :danger-text="$t('validation.required', { attribute: $t('users.role') })" v-model="form.role" :label='$t("users.role")')
            vm-select-item(:key="index" :value="item.text" :text="item.text" v-for="(item,index) in roles")
      vm-col(v-if="form.role === 'Admin'" vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-row(vm-justify="space-between")
            b {{ $t('users.has_branch') }}
            vm-switch(v-model="hasBranch")
      vm-col(v-if="needBranch()" vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-select(:placeholder='$t("branches.branch_placeholder")' :danger="$v.form.branch_id.$invalid && $v.form.branch_id.$model" :dange-text="$t('validation.required', {attribute: $t('branches.branch')})" v-model="form.branch_id" :label="$t('branches.branch')")
            vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item, index) in branches")
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required, requiredIf, minLength, email, sameAs } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers, mapGetters as configMapGetters } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Users')

export default {
  name: 'ModalUsers',
  mixins: [ModalMixin1],
  data: () => ({
    roles: [
      {
        text: 'Admin',
        value: 'Admin'
      },
      {
        text: 'Vendedor',
        value: 'Vendedor'
      },
      {
        text: 'Agente Aduanal',
        value: 'Agente Aduanal'
      },
      {
        text: 'Almacenista',
        value: 'Almacenista'
      }
    ],
    hasBranch: false
  }),
  validations () {
    return {
      form: {
        name: {
          required
        },
        email: {
          required,
          email
        },
        password: {
          required: requiredIf(password => {
            return this.isAdd
          }),
          minLength: minLength(4)
        },
        confirm_password: {
          required: requiredIf(confirmPassword => {
            return this.form.password
          }),
          sameAsPassword: sameAs('password')
        },
        role: {
          required
        },
        branch_id: {
          required: requiredIf(() => {
            return this.needBranch()
          })
        }
      }
    }
  },
  async created () {
    this.getBranches()
  },
  watch: {
    isModalVisible (value) {
      if (value) {
        this.form = { ...this.form, role: this.form.view_permissions[0] }
        this.hasBranch = Boolean(this.form.branch_id)
      }
    },
    hasBranch (value) {
      if (!value) {
        this.form = { ...this.form, branch_id: null }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalVisible', 'branches']),
    ...configMapGetters(['isSFS'])
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'deleteRecord',
      'setModalVisible',
      'getBranches'
    ]),
    needBranch () {
      return this.form.role === 'Almacenista' || (this.form.role === 'Admin' && this.hasBranch)
    },
    refreshPage () {
      window.location.reload()
    },
    async saveAndRefreshPage () {
      this.isAdd ? await this.addRecord(this.form) : await this.editRecord(this.form)
      this.refreshPage()
    }
  }
}
</script>
